export default __webpack_public_path__ + "static/new-survey-light-mode-6833a5e5e232c10d1768bf989620b75a.png";